import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../../hooks/useAuth';
import { Role } from '../../../../types/auth';

// Índice de /reporting según el rol (cada uno a lo primero que puede ver):
//  - RoomTeam → Comunicaciones Históricas (su único acceso dentro de Informes,
//    heredado de cuando el histórico vivía en la sección Comunicaciones).
//  - resto → Actuaciones Históricas (comportamiento previo).
// Tablet NO tiene acceso a Informes (ni a Gestión Horaria) — by-design.
// Los guards por ruta bloquean el acceso directo por URL a pantallas no
// permitidas para cada rol.
export default function ReportingIndexRedirect(): JSX.Element {
  const currentRole = useAuth()?.currentRole;
  let to = 'historical-actions';
  if (currentRole === Role.RoomTeam) to = 'historical-communications';
  return <Navigate to={to} replace />;
}
